<template>
    <span>{{ $t(statusText) }}</span>
</template>

<script>

import { getEntityAccountStatusById } from '@/composables/globalData/useEntitiesData'

export default {
    props: {
        userId: {
            type: Number,
            default: null
        },
        extension: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        statusData () {
            return getEntityAccountStatusById(this.extension.accountID, this.extension.representativeStatus)
        },
        statusText () {
            let text = this.statusData.Name || 'other'

            if (this.extension.calls && this.isTalking) {
                text = 'status.talking'
            }
            if (this.extension.calls && this.isCalling) {
                text = 'status.calling'
            }
            return this.$t(text)
        },
        isCalling () {
            if (this.extension.calls.length === 0) {
                return false
            }
            return this.extension.calls.every(c => c.callAnswered === 0)
        },
        isTalking () {
            if (this.extension.calls.length === 0) {
                return false
            }
            return this.extension.calls.every(c => c.callAnswered !== 0)
        }
    }
}
</script>
